import axios from 'axios';
import OAuthApi from './oauth';
import rootStore from 'store/rootStore';
import moment from 'moment';

export const API_URL = process.env.API_URL;

const attachConfig = (config) => {
    return {
        headers: {
            Authorization: 'Bearer ' + rootStore.auth.token.access_token,
        },
        ...config,
    }
};

const emptyStringToNull = (data) => {
    let d = {...data};

    for (let key in d) {
        if (d.hasOwnProperty(key) && d[key] === '') {
            d[key] = null;
        }
    }

    return d;
};

class Api {
    constructor() {
        this.OAuth = OAuthApi;
    }

    get(endpoint, config) {
        if (!rootStore.auth.token) {
            return Promise.reject('No token found');
        }

        const q = axios.get(API_URL + endpoint, attachConfig(config));
        q.catch(err => this.handle401(err));
        return q;
    }

    post(endpoint, data, config) {
        if (!rootStore.auth.token) {
            return Promise.reject('No token found');
        }

        const q = axios.post(API_URL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handle401(err));
        return q;
    }

    put(endpoint, data, config) {
        if (!rootStore.auth.token) {
            return Promise.reject('No token found');
        }

        const q = axios.put(API_URL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handle401(err));
        return q;
    }


    patch(endpoint, data, config) {
        if (!rootStore.auth.token) {
            return Promise.reject('No token found');
        }

        const q = axios.patch(API_URL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handle401(err));
        return q;
    }

    delete(endpoint, config) {
        if (!rootStore.auth.token) {
            return Promise.reject('No token found');
        }

        const q = axios.delete(API_URL + endpoint, attachConfig(config));
        q.catch(err => this.handle401(err));
        return q;
    }

    handle401(err) {
        if (axios.isCancel(err)) {
            // Don't do anything if request was cancelled
            return;
        }

        const { status } = err.response;

        if (status === 401) {
            rootStore.auth.invalidGrant(err);
        }
    }
}

export default new Api();

export const formatDate = (date) => {
    return moment(date).format('YYYY-MM-DD');
};


// WEBPACK FOOTER //
// ./src/api/api.js